// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const attachmentContentApiFeedbackAttachmentsAttachmentIdContentGetParamsDownloadDefault = false;
export const AttachmentContentApiFeedbackAttachmentsAttachmentIdContentGetParams = zod.object({
  "download": zod.boolean().default(attachmentContentApiFeedbackAttachmentsAttachmentIdContentGetParamsDownloadDefault)
})

export type AttachmentContentApiFeedbackAttachmentsAttachmentIdContentGetParams = zod.input<typeof AttachmentContentApiFeedbackAttachmentsAttachmentIdContentGetParams>;
export type AttachmentContentApiFeedbackAttachmentsAttachmentIdContentGetParamsOutput = zod.output<typeof AttachmentContentApiFeedbackAttachmentsAttachmentIdContentGetParams>;
